import React, { useContext, useEffect } from 'react';

import { RoadmapsContext } from 'common/containers/RoadmapsContainer';

import type { AddToRoadmap as AddToRoadmapType, Filter } from 'common/automations/constants';
import { Select } from 'common/uiV3/Select';

interface Props {
  filters: Filter[];
  properties: AddToRoadmapType['properties'];
  onChange: (properties?: AddToRoadmapType['properties']) => void;
}

const AddToRoadmap = ({ filters, ...props }: Props) => {
  const { roadmaps } = useContext(RoadmapsContext);

  const { properties, onChange } = props;
  const roadmapsAreValid = roadmaps && roadmaps.length > 0;

  const roadmapOptions = roadmapsAreValid
    ? roadmaps
        .filter((roadmap) => !roadmap.archived && !roadmap.deleted)
        .map((roadmap) => ({ label: roadmap.name, value: roadmap._id }))
    : null;
  const selectedOption = roadmapOptions?.find((option) => option.value === properties.roadmapID);

  // Set the roadmap to the first one
  useEffect(() => {
    if (roadmapOptions && !selectedOption) {
      onChange({ roadmapID: roadmapOptions[0].value });
    }
  }, [roadmapOptions, onChange, selectedOption]);

  // Should probably never happen, companies must have at least one roadmap
  if (!roadmapOptions || !selectedOption) {
    return null;
  }

  return (
    <div className="grid2">
      <Select
        onValueChange={(option) => option && onChange({ roadmapID: option })}
        options={roadmapOptions}
        placeholder="Select a roadmap"
        value={selectedOption?.value}
        fullWidth
        isSearchable={roadmapOptions.length > 5}
      />
    </div>
  );
};

export default AddToRoadmap;
